import { cloneStyled } from '@utils/cloneStyled';
import styled from 'styled-components';
import Text from './Text';

export const BreakingText = cloneStyled(
  Text,
  styled(Text)`
    word-break: break-word;
    white-space: normal;
  `,
);
export const TruncatedText = cloneStyled(
  Text,
  styled(Text)`
    overflow: hidden;
    word-break: break-word;
    text-overflow: ellipsis;
  `,
);
